<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body {
  width: 100%;
  height: 100%;
}
.widget{
  z-index: 999;
  position: absolute;
}
* {
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
  font-family: "微软雅黑", SimSun, sans-serif;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color:black;
  width: 100%;
  height: 100%;
}
li{
  list-style: none;
}
.mydialog{
    .el-row,el-col{
        height: 40px;
        line-height: 40px;
    }
}


.marker-text {
  /* text-shadow: 0 1px orangered, 1px 0 orangered, -1px 0 orangered, 0 -1px orangered; */
  width: 48px;
  text-align: center;
  color: blue;
  font-weight: bold;
  font-size: 16px;
}

.rectangle-label{
  color: red;
  font-size: 1.5em;
}
/* 绘制的时候的信息提示框样式*/
.tips{
  background: #0008;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue